// src/components/Footer.jsx
import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section about">
          <h3>About Type Click Tests</h3>
          <p>Free cheetah typing tests and a 5 second click test. Get WPM, CPM, CPS, and an animal rank — no signup.</p>
        </div>
        <div className="footer-section links">
          <h3>Tests</h3>
          <ul>
            <li><Link to="/60s-cpm-typing-test/">1 Minute Typing Test</Link></li>
            <li><Link to="/15s-cpm-typing-test/">15 Second Typing Test</Link></li>
            <li><Link to="/1s-cps-click-test/">1 Second CPS Burst</Link></li>
            <li><Link to="/5s-cps-click-test/">5 Second Click Test</Link></li>
            <li><Link to="/60s-cps-click-test/">1 Minute Click Test</Link></li>
          </ul>
        </div>
        <div className="footer-section links">
          <h3>Games</h3>
          <ul>
            <li><Link to="/higher-or-lower/">Higher or Lower</Link></li>
            <li><Link to="/color-memory/">Color Memory</Link></li>
            <li><Link to="/stop-the-wheel/">Stop the Wheel</Link></li>
            <li><Link to="/guess-the-country/">Guess the Country</Link></li>
            <li><Link to="/reaction-test/">F1 Reaction Test</Link></li>
          </ul>
        </div>
        <div className="footer-section links">
          <h3>Site</h3>
          <ul>
            <li><Link to="/blog/">Blog</Link></li>
            <li><Link to="/about-typing-clicking-tests/">About</Link></li>
            <li><Link to="/privacy/">Privacy Policy</Link></li>
            <li><Link to="/terms/">Terms and Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Type Click Tests. All rights reserved.</p>
      </div>
    </footer>
  );
}
